import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { firmInfo } from '../mockData';

const Contact = () => {

  return (
    <div>
      <Helmet>
        <title>Contact | D J Govindaraju and Associates - Advocates in Bengaluru</title>
        <meta name="description" content="Reach D J Govindaraju and Associates, advocates and legal practitioners in Gandhi Nagar, Bengaluru. Seasoned in dispute resolution and arbitration. Office at Thimmaiah Towers, Gandhi Nagar. Phone: +91 9845871216." />
        <link rel="canonical" href="https://www.djgovindaraju.com/contact" />
      </Helmet>
      {/* Hero Section */}
      <section
        style={{
          background: 'var(--gradient-hero-brown)',
          padding: '10rem 1.5rem 5rem',
          textAlign: 'center'
        }}
      >
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1 className="heading-hero" style={{ marginBottom: '1.5rem', color: 'var(--text-light)' }}>
            Contact Us
          </h1>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="section" style={{ background: 'var(--bg-page)' }}>
        <div className="container">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '3rem',
              marginBottom: '4rem'
            }}
          >
            {/* Contact Information Cards */}
            <div className="card hover-lift" style={{ display: 'flex', gap: '1.25rem' }}>
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'var(--gradient-section-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                <MapPin size={24} style={{ color: 'var(--accent-gold-dark)' }} />
              </div>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>
                  Office Address
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {firmInfo.address}
                </p>
              </div>
            </div>

            <div className="card hover-lift" style={{ display: 'flex', gap: '1.25rem' }}>
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'var(--gradient-section-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                <Phone size={24} style={{ color: 'var(--accent-gold-dark)' }} />
              </div>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>
                  Phone
                </h3>
                <a
                  href={`tel:${firmInfo.phone}`}
                  style={{ color: 'var(--accent-gold-dark)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  {firmInfo.phone}
                </a>
              </div>
            </div>

            <div className="card hover-lift" style={{ display: 'flex', gap: '1.25rem' }}>
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'var(--gradient-section-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                <Mail size={24} style={{ color: 'var(--accent-gold-dark)' }} />
              </div>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>
                  Email
                </h3>
                <a
                  href={`mailto:${firmInfo.email}`}
                  style={{ color: 'var(--accent-gold-dark)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  {firmInfo.email}
                </a>
              </div>
            </div>

            <div className="card hover-lift" style={{ display: 'flex', gap: '1.25rem' }}>
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'var(--gradient-section-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                <Clock size={24} style={{ color: 'var(--accent-gold-dark)' }} />
              </div>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>
                  Office Hours
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {firmInfo.hours}
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="card" style={{ padding: 0, overflow: 'hidden', minHeight: '500px' }}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.784537837982!2d77.5754792!3d12.9756726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1766642140bf%3A0x1b1ed9bcdd17536a!2sD%20J%20Govindaraju%20and%20Associates!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '500px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="D J Govindaraju and Associates Office Location"
              />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
